var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeedling(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--noto",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.47 48.2l-1.11 18.48s3.76 10.64 2.71 25.45c-1.01 14.27-4.8 21.49-5.84 23.99s-3.96 5.63 0 6.88s10.64.63 13.56-.42c2.92-1.04 4.37-6.84 4.8-9.18c1.05-5.79 1.63-16.74-.5-27.54C79.46 77.56 76 63.33 76 63.33L67.47 48.2z",
    fill: "#99c23b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.78 45.4s4.28-13.43 14.12-23.62c9.43-9.76 19.06-12.96 26.78-13.92c8.51-1.06 11.98-.95 13.44.1s.94 2.7.97 4.16c.19 10.44.58 23.97-11.7 36.35c-13.11 13.2-22.45 15.57-32.68 16.62c-10.22 1.04-9.06-3.62-9.06-3.62L66.78 45.4z",
    fill: "#99c23b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.98 37.05c-.37 1.83 9.29 23.31 27.95 30.07c20.09 7.29 39.03 0 39.03 0l1.56-19.34l-4.75-2.38S56.7 34.29 45.51 30.19c-11.6-4.25-24.71-4.58-33.64.19c-5.6 3-8.69 5.7-8.89 6.67z",
    fill: "#99c23b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.68 30.68C77.38 41.7 72.69 52.81 72.2 55.71s1.12 2.78 2.03 1.55c1.64-2.22 7.35-12.37 15.85-22.04c7.36-8.36 18.56-17.4 20.2-19.33c1.02-1.2-.1-2.71-1.64-2.03c-1.54.67-12.45 5.55-21.96 16.82z",
    fill: "#e6dc9f"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.43 41c-13.6-4.68-23.55-4.05-25.58-3.37c-2.03.68-1.93 2.9.48 3.19s12.24 1.27 24.56 5.7c13.15 4.74 22.52 11.89 24.17 12.86c1.64.97 2.71-.97 1.26-2.71c-1.11-1.31-9.89-10.51-24.89-15.67z",
    fill: "#e6dc9f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeedling);
export default __webpack_public_path__ + "static/media/seedling.e3bd36c9041de8f4183b1d3e3777c1ac.svg";
export { ForwardRef as ReactComponent };